<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      title="万金油消费记录"
      width="1000px"
      :before-close="close"
      resize
    >
      <vxe-toolbar
        id="toolbarId_cc2"
        :custom="{ storage: true }"
        :refresh="{ query: RefreshList }"
        export
      >
        <template v-slot:buttons>
          <el-button type="primary" @click="funcFilter()">查询</el-button>
        </template>
      </vxe-toolbar>
      <vxe-table
        ref="xTable"
        border
        resizable
        stripe
        class="mytable-style"
        highlight-hover-row
        highlight-current-row
        row-id="id"
        height="500"
        :data="tableData"
        :loading="loading"
        :sort-config="{ remote: true }"
        export-config
        show-overflow
        align="center"
      >
        <vxe-table-column
          field="mcName"
          title="实际承运人姓名"
          min-width="180"
        />
        <vxe-table-column
          field="memberMobile"
          title="实际承运人手机号"
          min-width="180"
        />
        <vxe-table-column
          field="carNo"
          title="实际承运人车牌号"
          min-width="180"
        />
        <vxe-table-column field="orderId" title="订单id" min-width="180" />
        <vxe-table-column
          field="orderStatus"
          title="交易状态"
          min-width="180"
        />
        <vxe-table-column field="quantity" title="加油升数" min-width="180" />
        <vxe-table-column field="price" title="单价(元)" min-width="180" />
        <vxe-table-column
          field="totalMoney"
          title="应交易金额(元)"
          min-width="180"
        />
        <vxe-table-column
          field="mcPayMoney"
          title="实际交易金额(元)"
          min-width="180"
        />
        <vxe-table-column
          field="stationName"
          title="油站名称"
          min-width="180"
        />
        <vxe-table-column field="fuelName" title="油品名称" min-width="180" />
        <vxe-table-column>
          <vxe-table-column
            field="createTime"
            title="创建时间"
            min-width="240"
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.createTimeRange"
              type="datetimerange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="optionsPicker"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="changeTime"
            />
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
        :loading="loading"
        :current-page.sync="listQuery.pageNum"
        :page-size.sync="listQuery.pageSize"
        :page-sizes="Pagingconf"
        :total="listQuery.total"
        :layouts="[
          'PrevJump',
          'PrevPage',
          'Number',
          'NextPage',
          'NextJump',
          'Sizes',
          'FullJump',
          'Total'
        ]"
        @page-change="handlePageChange"
      />
    </vxe-modal>
  </div>
</template>

<script>
import { getOrderRecord } from "@/api/userOil";
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tableData: [],
      Pagingconf: [20, 50, 100, 200, 500],
      listQuery: {
        createTimeRange: "",
        updateTimeRange: "",
        name: "",
        username: "",
        carNo: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        start: 0
      }
    };
  },
  created() {},
  methods: {
    show(item) {
      this.tableData = [];
      this.dialogVisible = true;
      // this.listQuery.name = item.name
      this.listQuery.memberMobile = item.phone;
      this.listQuery.carNo = item.vehicleLicenseNumber;
      this.initQuery = JSON.stringify(this.listQuery);
      this.findList();
    },
    funcFilter() {
      this.listQuery.pageNum = 1;
      this.findList();
    },
    RefreshList() {
      this.listQuery = JSON.parse(this.initQuery);
      return this.findList();
    },
    // 获取/查询 列表
    findList() {
      this.loading = true;
      this.listQuery.start =
        (this.listQuery.pageNum - 1) * this.listQuery.pageSize;
      return getOrderRecord(this.listQuery)
        .then(response => {
          this.tableData = response.data.records || [];
          this.listQuery.total = response.data.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页handle
    handlePageChange({ currentPage, pageSize }) {
      this.listQuery.pageNum = currentPage;
      this.listQuery.pageSize = pageSize;
      this.findList();
    },
    // 关闭
    close() {
      this.dialogVisible = false;
    },
    formatBank({ cellValue }) {
      const item = this.bankList.find(item => item.code === cellValue);
      return item ? item.name : "";
    },
    // 创建时间
    changeTime(value) {
      if (value) {
        this.listQuery.startTime = value[0];
        this.listQuery.endTime = value[1];
      } else {
        this.listQuery.startTime = "";
        this.listQuery.endTime = "";
      }
    },
    // 交易时间/更新时间
    changeUpdateTime(value) {
      if (value) {
        this.listQuery.updateStartTime = value[0];
        this.listQuery.updateEndTime = value[1];
      } else {
        this.listQuery.updateStartTime = "";
        this.listQuery.updateEndTime = "";
      }
    }
  }
};
</script>
<style scoped lang="scss"></style>
